/* tslint:disable */
/* eslint-disable */
/**
 * UI schemas for iDeed ARCGx v2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enumeration representing a LegalEntity's party relation to a Tripartite contract
 * @export
 */
export const TriContractPartyGroupRoleType = {
    APPLICANT: 'APPLICANT',
    BENE: 'BENE',
    NEWBENE: 'NEWBENE',
    ISSUER: 'ISSUER',
    ORACLE: 'ORACLE',
    IDEED: 'IDEED'
} as const;
export type TriContractPartyGroupRoleType = typeof TriContractPartyGroupRoleType[keyof typeof TriContractPartyGroupRoleType];


export function TriContractPartyGroupRoleTypeFromJSON(json: any): TriContractPartyGroupRoleType {
    return TriContractPartyGroupRoleTypeFromJSONTyped(json, false);
}

export function TriContractPartyGroupRoleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriContractPartyGroupRoleType {
    return json as TriContractPartyGroupRoleType;
}

export function TriContractPartyGroupRoleTypeToJSON(value?: TriContractPartyGroupRoleType | null): any {
    return value as any;
}

